export const corporative = {
    backgroundImage: '/images/corporative_section/Corporate_Innovation.png',
    backgroundImageMobi: '/images/corporative_section/Corporate_Innovation_mbl.png',
    programName: 'Corporate Innovation Program',
    week: ' ',
    programdescription: 'The goal of this 5 week hybrid Executive Program is to expose '+
    ' corporate and startup executives to the Silicon Valley mindset, expertise and ecosystem.',
    programdescription_mbl: 'The goal of the Executive Program is to expose corporate and startup executives '+
    ' to the Silicon Valley mindset, expertise  and ecosystem.',
    points: [{sesion: 'Summer, 2023'}, {sesion: 'July'}],
    points2: [{sesion: ''}, {sesion: ''}],
    img: '/images/3boxesProgrampagesSection2.svg',
    img_mbl: '/images/mobile.svg',
    success_description: 'Gain necessary knowledge, experience, and '+
    'leadership skills to bring innovation back to your company and team.',
};
export const fundamental = {
    backgroundImage: '/images/fundamental_programs/Draper_University_Hero_Training_Summer.png',
    backgroundImageMobi: '/images/fundamental_programs/back_img_mobile.png',
    programName: 'Fundamentals Of Entrepreneurship Program',
    programdescription: ' Be a Startup Hero in 30 hours.',
    programdescription_mbl: 'An intensive, immersive five-week <br> pre-accelerator program in Silicon <br> Valley.',
    week: ' (2 weeks - Virtual)',
    points: [{sesion: 'Spring, 2023'}, {sesion: 'April 4 - April 18'}],
    points2: [{sesion: ''}, {sesion: ''}],
    img: '/images/3boxesProgrampagesSection2.svg',
    img_mbl: '/images/mobile.svg',
    success_description: 'Learning and networking with over 50 '+
    'Silicon Valley experts, mentors and global entrepreneurs.',
};
export const houseceek = {
    backgroundImage: '/images/houseCeekPage/desktop_BG.png',
    backgroundImageMobi: '/images/houseCeekPage/mobile_BG.png',
    programName: 'House of CEEK',
    programdescription: `AVR Builders & Game Developers!<br> We’re looking for you!Do you have what it takes?`,
    programdescription_mbl: `AVR Builders & Game Developers!<br>We’re looking for you! <br> Do you have what it takes?`,
    week: ' ',
    points: [{sesion: 'Your journey into the CEEK <br> metaverse starts 01/23/2023'}, {sesion: ''}],
    points2: [{sesion: ''}, {sesion: ''}],
    img: '/images/3boxesProgrampagesSection2.svg',
    img_mbl: '/images/mobile.svg',
    success_description: 'This revolutionary program will allow you to create groundbreaking assets for the'+
    ' CEEK metaverse at DraperU in Silicon Valley. Selected participants for House of'+
    ' CEEK will have their programmatic costs covered.',
};
export const vcx = {
    backgroundImage: '/images/vcx_program/vcx.png',
    backgroundImageMobi: '/images/vcx_program/vcx_mbl.png',
    programName: 'VCx',
    programdescription: 'A week with the best VCs in Silicon Valley.',
    programdescription_mbl: 'A week with the best <br> VCs in Silicon Valley.',
    week: ' ',
    points: [{sesion: 'Fall, Oct 2022'}, {sesion: ''}],
    points2: [{sesion: ''}, {sesion: ''}],
    img: '/images/3boxesProgrampagesSection2.svg',
    img_mbl: '/images/mobile.svg',
    success_description: 'Where new generations of entrepreneurial families around the world build and network with '+
    'top Silicon Valley VCs and founders leading the future. ',
};
export const corporativeForSection = {
    number: ' 03',
    for: 'For...',
    points: [{
        title: 'Startup & Corporate Executives',
        description: 'The Executive program is for corporate and startup executives who are '+
        'looking for the next big thing, be that within their own company or the next venture.'+
        ' Senior manager and director-level corporate and startup executives from around the world,'+
        ' corporate intrapreneurs and product leaders have attended our programs.',
        action: 'APPLY NOW',
        goahead: '/images/corporative_section/Line 216.svg',
    },
    ],
    src1: '/images/corporative_section/83514589_2701812689937121_9056403443761020928_n.png',
    src2: '/images/corporative_section/Draper-startuphouse-startuptalky-1.png',
    src3: '/images/corporative_section/image-asset 2.png',
};
export const vcxForSection = {
    number: ' 03',
    for: 'For...',
    points: [{
        title: 'This Program is For',
        description: `Once a year, we invite 15 members of prominent entrepreneurial `+
        'families from around the world, and invite'+
        ' them to spend four days with the best VCs in Silicon Valley,'+
        ' learning how they evaluate early-stage investments, '+
        `and looking into today's innovative startups. `,
        action: 'APPLY NOW',
        goahead: '/images/corporative_section/Line 216.svg',
    },
    ],
    src1: '/images/corporative_section/83514589_2701812689937121_9056403443761020928_n.png',
    src2: '/images/corporative_section/Draper-startuphouse-startuptalky-1.png',
    src3: '/images/corporative_section/image-asset 2.png',
};
export const forSection = {
    number: ' 03',
    for: 'For...',
    points: [{
        title: 'Startup & Corporate Executives',
        description: 'The Executive program is for corporate and startup executives who are '+
        'looking for the next big thing, be that within their own company or the next venture. '+
        'Senior manager and director-level corporate and startup executives from around the world,'+
        ' corporate intrapreneurs and product leaders have attended our programs.',
        action: 'APPLY NOW',
        goahead: '/images/corporative_section/Line 216.svg',
        src1: '/images/corporative_section/83514589_2701812689937121_9056403443761020928_n.png',
    },
    {
        title: 'Startup & Corporate Executives',
        description: 'The Executive program is for corporate and startup executives who are looking '+
        'for the next big thing, be that within their own company or the next venture. Senior manager '+
        'and director-level corporate and startup executives from around the world, corporate intrapreneurs'+
        ' and product leaders have attended our programs.',
        action: 'APPLY NOW',
        goahead: '/images/corporative_section/Line 216.svg',
        src1: '/images/corporative_section/83514589_2701812689937121_9056403443761020928_n.png',
    }],
    src2: '/images/corporative_section/Draper-startuphouse-startuptalky-1.png',
    src3: '/images/corporative_section/image-asset 2.png',
};
export const corporativeAccelerateForSection = {
    number: ' 02',
    for: 'For...',
    points: [{
        title: 'Enterprise',
        description: 'Enterprise looking to fast-track their own innovation strategy by learning to be '+
        'more lean and agile or by partnering with external startups to help solve internal challenges or '+
        'to invest in their own possible disruption.',
        action: 'APPLY NOW',
        goahead: '/images/corporative_section/Line 216.svg',
    },
    ],
    src1: '/images/corporative_section/83514589_2701812689937121_9056403443761020928_n.png',
    src2: '/images/corporative_section/Draper-startuphouse-startuptalky-1.png',
    src3: '/images/corporative_section/image-asset 2.png',
};
export const benifateSection = {
    number: '04',
    title: ' Benefits of this Program',
    description: 'This program is for executives and corporate innovation managers looking to '+
    'upskill or stay on trend with the most up to date learning from Silicon Valley founders and '+
    'entrepreneurial academics. We provide insights on upcoming technology, its impact, and future-forward '+
    'thinking to innovate with a 10X mentality. The learning is supplemented with both practical learning and '+
    'tactical application in both corporate innovation and venture capital investment. Leave feeling confident'+
    ' about your innovation strategy.',
};
export const benifateSectionForVcx = {
    number: '01',
    title: ' What is VCx',
    description: `The film Something Venture documented the emergence of Silicon Valley venture capitalism.'+
    ' In the mid-20th century, when both terms hadn't even been coined. Today, as entrepreneurship and innovation '+
    'have become the engine for economic growth, the world of capital investments needs to address a major bottleneck:'+
    ' the lack of VC know-how. Founded in July 2014, VCx is bridging the new generations of entrepreneurial '+
    'families with '+
    'the best VCs in Silicon Valley...including some of its founding fathers.`,
};
export const corporateAccelerate = {
    backgroundImage: '/images/corporative_accelerate/Draper University Hero Training Summer 2021-DSC07946 1.png',
    backgroundImageMobi: '/images/corporative_accelerate/Draper University Hero Training Summer 2021-DSC07946 2.png',
    programName: 'CORPORATE ACCELERATOR',
    programdescription: 'Future-proof your business by investing and building '+
    'with the most exciting startups in your industry. ',
    programdescription_mbl: 'Future-proof your business by <br> investing and building with the '+
    'most <br> exciting startups in your industry. ',
    week: ' ',
    points: [{sesion: 'Custom Dates'}, {sesion: ''}],
    points2: [{sesion: ''}, {sesion: ''}],
    sesion: 'Custom Dates',
    img: '/images/3boxesProgrampagesSection2.svg',
    img_mbl: '/images/mobile.svg',
    success_description: 'Gain necessary knowledge, experience,'+
    ' and leadership skills to bring innovation back to your company and team.',

};
export const heroTraining = {
    backgroundImage: '/images/Hero_section/hero_back_img.png',
    backgroundImageMobi: '/images/Hero_section/hero_back_img_mbl.png',
    programName: 'Hero Training',
    programdescription: 'An intensive, immersive five-week pre-accelerator program in Silicon Valley.',
    programdescription_mbl: 'An intensive, immersive five-week <br> pre-accelerator program in Silicon <br> Valley.',
    week: ' ',
    points: [{sesion: 'Summer, 2023'}, {sesion: 'May 22 - June 23'}],
    points2: [{sesion: 'Fall, 2023'}, {sesion: 'Oct 9 - Nov 10'}],
    img: '/images/3boxesProgrampagesSection2.svg',
    img_mbl: '/images/mobile.svg',
    success_description: 'Change the world as you live, learn and grow with some ofthe smartest'+
    ' minds and the most ambitious people from around the world.',
};
export const globalPage = {
    backgroundImage: '/images/global_section/global_back_img.png',
    backgroundImageMobi: '/images/global_section/global_back_img_mbl.png',
    programName: 'Global Government Partnership',
    programdescription: 'Meet your development goals with us! ',
    programdescription_mbl: 'An intensive, immersive five-week <br> pre-accelerator program in Silicon <br> Valley ',
    week: ' ',
    points: [{sesion: ''}, {sesion: ''}],
    points2: [{sesion: ''}, {sesion: ''}],
    img: '/images/3boxesProgrampagesSection2.svg',
    img_mbl: '/images/mobile.svg',
    success_description: ' Partner with us to strengthen the innovation and entrepreneurship '+
    'ecosystem in your country and reach your development goals.',
};
export const kanoo = {
    backgroundVedio: '/images/backgroundVedio.mp4',
    backgroundVedioMobi: '/images/backgroundVedio.mp4',
    programName: 'Kanoo Innovation Hub',
    programdescription: 'Do you want to learn about building your own technology '+
    'business? Scale an existing startup? Get in front of global investors?',
    programdescription_mbl: 'Partner with us to accelerate your blockchain ecosystem with superhero founders.',
    week: '',
    points: [{sesion: ''}, {sesion: ''}],
    points2: [{sesion: ''}, {sesion: ''}],
    img: '/images/3boxesProgrampagesSection2.svg',
    img_mbl: '/images/mobile.svg',
    successDescription: 'A program designed to develop innovation technology '+
    'businesses. We will take you from the beginning to the future !',
};
export const benifateSectionKanoo = {
    number: '01',
    title: ' What is Kanoo',
    description: 'We are developing and investing in the most powerful startups in the'+
    ' Caribbean along with Kanoo Innovation Hub Draper University’s track record in supporting '+
    'ideas and startups is unparalleled - from Draper’s early investments in Bitcoin, Ethereum and'+
    ' Coinbase through to Boost VCbacking Sci-Fi Startups. We have partnered with Vechain, '+
    'Neo Launchpad, Tezos and Algorand Foundation.',
};
export const globalForSection = {
    number: ' 01',
    for: 'For...',
    points: [{
        title: 'This Program is For',
        description: 'Countries looking to become leaders in new science and technology sectors '+
        'of global interest, accelerate new job creation, invest in youth leadership and development '+
        'with globally competitive skill-sets, and generate innovative ideas and solve challenging problems.',
        action: 'APPLY NOW',
        goahead: '/images/corporative_section/Line 216.svg',
    },
    ],
    src1: '/images/corporative_section/83514589_2701812689937121_9056403443761020928_n.png',
    src2: '/images/corporative_section/Draper-startuphouse-startuptalky-1.png',
    src3: '/images/corporative_section/image-asset 2.png',
};
export const sliderFromRight = [
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Maria_Sofia_Castillo/Maria_Sofia_Castillo.png ',
        person_name: 'Maria Sofia Castillo',
        date: 'January 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Maria_Sofia_Castillo/core_code.png',
        width: '6.680vw',
        company_name: 'Core Code',
        logo_right_margin: '0vw',
        description: '',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Jennifer_Wong/Jennifer_Wong.png',
        person_name: 'Jannifer Wong',
        date: 'January 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Jennifer_Wong/phyta_zenica.png',
        width: '2.381vw',
        company_name: 'Phyta Zenica',
        logo_right_margin: '0vw',
        description: '',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Murad_Nathani/Murad_Nathani.png',
        person_name: 'Murad Nathani',
        date: 'January 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Murad_Nathani/Sepio Solutions.png',
        width: '3.307vw',
        company_name: 'Sepio',
        logo_right_margin: '0.5vw',
        description: '',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_'+
        'Alumni/Alessandra_Menezes_Morelle/Alessandra_Menezes_Morelle.png',
        person_name: 'Menezes _Morelle',
        date: 'January 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Alessandra_Menezes_Morelle/thummi.svg',
        width: '5.886vw',
        company_name: 'Thummi',
        logo_right_margin: '0vw',
        description: '',

    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Jeff_Hu/Jeff_Hu.png',
        person_name: 'Jeff Hu',
        date: 'September 2021',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Jeff_Hu/turning curts.svg',
        width: '3.468vw',
        company_name: 'Turing Certs',
        logo_right_margin: '1.7vw',
        description: '',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Linjian_Xiang/Linjian_Xiang.png',
        person_name: 'Linjian Xiang',
        date: 'October 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Linjian_Xiang/Robolution.png',
        width: '3.307vw',
        company_name: 'Robolution ',
        logo_right_margin: '1.3vw',
        description: '',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Maria_Mateo_Iborra/Maria_Mateo_Iborra.png',
        person_name: 'Maria Meteo Iborra',
        date: 'June 2021',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Maria_Mateo_Iborra/Ibisa Network.png',
        width: '3.968vw',
        company_name: 'Ibisa',
        logo_right_margin: '0vw',
        description: '',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Amy_Chen/Amy_Chen.png',
        person_name: 'Amy Chen',
        date: 'June 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Amy_Chen/Vaultbase.png',
        width: '2.910vw',
        company_name: 'Vaultbase ',
        logo_right_margin: '1.2vw',
        description: '',
    },
];
export const sliderHeroTraining = [
    {
        image: 'images/Hero_section/hero_alumni/guillaume_rolland.png',
        person_name: 'Guillaume Rolland',
        company_logo: 'images/Hero_section/hero_alumni/sensorwake.png',
        width: '7.870vw',
        logo_right_margin: '0vw',
        description: 'Acquired by Google',
        logo_top_margin: '4.5vw',
    },
    {
        image: 'images/Hero_section/hero_alumni/surbhi_sarna.png',
        person_name: 'Surbhi Sarna',
        company_logo: 'images/Hero_section/hero_alumni/nVision.png',
        width: '12.368vw',
        logo_right_margin: '0vw',
        description: 'Global Partner at <br> Y Combinator',
        logo_top_margin: '-1vw',
    },
    {
        image: 'images/Hero_section/hero_alumni/patrick_dai.png',
        person_name: 'Patrick Dai',
        company_logo: 'images/Hero_section/hero_alumni/qtum.svg',
        width: '3.880vw',
        logo_right_margin: '0vw',
        description: '$2B+ Market Cap',
        logo_top_margin: '0vw',
    },
    {
        image: 'images/Hero_section/hero_alumni/carly_martinetti.png',
        person_name: 'Carly Martinetti',
        company_logo: 'images/Hero_section/hero_alumni/pretty_litter.svg',
        width: '5.093vw',
        logo_right_margin: '0vw',
        description: 'Pretty Litter over $500M acquisition by Mars Petcare',
        logo_top_margin: '0vw',
    },
    {
        image: 'images/Hero_section/hero_alumni/ryan_moon.png',
        person_name: 'Ryan Moon',
        company_logo: 'images/Hero_section/hero_alumni/newsy_stock.svg',
        width: '4.696vw',
        logo_right_margin: '0vw',
        description: 'Newsystock acquired by Dayli Financial Group in Korea',
        logo_top_margin: '-1vw',
    },
];
export const sliderFromLeft = [
    {
        image: 'images/Hero_training_companies_logos/loopd_03.svg ',
        person_name: 'Looped Inc',
        company_name: 'Brian Friedman',
        logo_width: '6.217vw',
        div_width: '8.6vw',
    },
    {
        image: 'images/Hero_training_companies_logos/Benjamin Ries, Summer 2013, Roby.svg',
        person_name: 'Roby',
        company_name: 'Benjamin Ries',
        logo_width: '10.648vw',
        div_width: '11.648vw',
    },
    {
        image: 'images/Hero_training_companies_logos/Amira Geneid, Fall 2014, Zahara.svg',
        person_name: 'Zahara',
        company_name: 'Amira Geneid',
        logo_width: '5.952vw',
        div_width: '7.9vw',
    },
    {
        image: 'images/Hero_training_companies_logos/Akshay Chaturvedi, Spring 2015, Leverage_Logo.svg',
        person_name: 'Leverage',
        company_name: 'Akshay Chaturvedi',
        logo_width: '7.275vw',
        div_width: '10.3vw',
    },
    {
        image: 'images/Hero_training_companies_logos/Adegoke (Goke) Olubusi, Summer 2014, Helium Health.svg',
        person_name: 'Helium Health',
        company_name: 'Adegoke Olubusi',
        logo_width: '15.344vw',
        div_width: '15.344vw',
    },
    {
        image: 'images/Hero_training_companies_logos/Luciano Bueno, Spring 2015, GALY.svg',
        person_name: 'Galy',
        company_name: 'Luciano Bueno ',
        logo_width: '5.225vw',
        div_width: '7.5vw',
    },
    {
        image: 'images/Hero_training_companies_logos/Matt Blanchard, Algorand 2021.svg',
        person_name: 'Cosmic Champs ',
        company_name: 'Matt Blanchard',
        logo_width: '6.944vw',
        div_width: '9.2vw',
    },
    {
        image: 'images/Hero_training_companies_logos/Konstantin Maslennikov, Summer 2017, TakeBus.svg',
        person_name: 'Take Bus',
        company_name: 'Konstantin Maslennikov ',
        logo_width: '8.267vw',
        div_width: '11.4vw',
    },
];
export const socailLogo = [
    {
        img1: '/images/fundamental_programs/DUV_Logos/Blowhorn.png',
        img1_width: '10vw',
        img1_height: '3vw',
        img2: '/images/fundamental_programs/DUV_Logos/Ibisa.png',
        img2_width: '10vw',
        img2_height: '3vw',
        img3: '/images/fundamental_programs/DUV_Logos/Strive.png',
        img3_width: '10vw',
        img3_height: '3vw',
        img4: '/images/fundamental_programs/DUV_Logos/Blue.png',
        img4_width: '6vw',
        img4_height: '6vw',
    },
    {
        img1: '/images/fundamental_programs/DUV_Logos/ELSI.png',
        img1_width: '10vw',
        img1_height: '6vw',
        img2: '/images/fundamental_programs/DUV_Logos/Boon.png',
        img2_width: '10vw',
        img2_height: '6vw',
        img3: '/images/fundamental_programs/DUV_Logos/Quilo.png',
        img3_width: '10vw',
        img3_height: '6vw',
        img4: '/images/fundamental_programs/DUV_Logos/Qikfox.png',
        img4_width: '7vw',
        img4_height: '7vw',
    },
    {
        img1: '/images/fundamental_programs/DUV_Logos/Bayseddo.png',
        img1_width: '10vw',
        img1_height: '7vw',
        img2: '/images/fundamental_programs/DUV_Logos/Busy.png',
        img2_width: '10vw',
        img2_height: '',
        img3: '/images/fundamental_programs/DUV_Logos/Ecoin.png',
        img3_width: '10vw',
        img3_height: '',
        img4: '/images/fundamental_programs/DUV_Logos/Funa.png',
        img4_width: '10vw',
        img4_height: '',
    },
    {
        img1: '/images/fundamental_programs/DUV_Logos/Airschool.png',
        img1_width: '10vw',
        img1_height: '',
        img2: '/images/fundamental_programs/DUV_Logos/Indus-Valley.png',
        img2_width: '10vw',
        img2_height: '',
        img3: '/images/fundamental_programs/DUV_Logos/Here-You-Go.png',
        img3_width: '10vw',
        img3_height: '',
        img4: '/images/fundamental_programs/DUV_Logos/Creative-Protein.png',
        img4_width: '10vw',
        img4_height: '',
    },
];
export const FaqCorporateAccelerate = [
    {
        heading: 'What type of startups do you accelerate?',
        text: 'At this stage, we are looking for scale-ups with a market-ready '+
            'solution and that the team is ready to work with enterprises, ideally, '+
            'there is a track record of working with corporates on proof of concepts.',
    },
    {
        heading: 'What results can we expect?',
        text: 'You can expect a few major benefits; the ability to solve problems using '+
        'the agile solutions of the startups, to make solid investments, and to have a lot of fun. '+
        'We find the accelerators are just as much a learning experience for the partners as it is for '+
        'the participants.',
    },
    {
        heading: 'What are the associated costs?',
        text: 'Our general cost is dependent on the length of time (typically 3 months) and the amount of'+
        ' investment in each of the startups, we suggest somewhere between $30-100k per team in order to ensure '+
        'high-quality teams, with viable businesses intensely focused on building complementary products and services.',
    },
];
export const faqGlobal = [
    {
        heading: 'Why is Draper University?',
        text: 'Draper University is the most integral part of the Draper’s Larger Ecosystem. '+
            'We feed the entire ecosystem with talent, opportunities and exceptional individuals '+
            'who we train and mentor. Once they are ready, we provide them with seed funding,'+
            ' networking opportunities and options to stay at our entrepreneurs residence in Silicon'+
            ' Valley. We have 2100+ Alumni who come from 100 different countries and have raised $450 '+
            'million while creating 5000+ jobs.',
    },
    {
        heading: 'What value will we get partnering with Draper University?',
        text: 'With our years of experience in Venture Capital, Disruptive Technologies and '+
        'Entrepreneurship Education. We bring with us a complete ecosystem: a wide global network, '+
        'a strong team of experts and high growth venture advisory. For result oriented growth Draper University '+
        'is a capacity building, trust-worthy and expert Partner.',
    },
    {
        heading: 'What are the requirements for startups/individuals joining the programs at Draper University?',
        text: 'We have an extremely diligent process of interviewing and working with individuals. We don’t '+
        'just focus on specific numbers, we work with individuals who we can establish as successful founders and'+
        ' visionaries. We then mentor and fund their ideas to become scalable companies.',
    },
    {
        heading: 'Are there Co-Funding Opportunities?',
        text: 'Yes, we will be happy to put you in touch with our investment team to explore co-funding opportunities.',
    },
    {
        heading: 'Are there custom programs that can be designed for '+
            'specific economic/technological needs of the country?',
        text: 'Yes, we have a dedicated team that  will work with you to put together a milestones '+
            'based program. This will include need assessment, curriculum development, funding methodology '+
            ' and a complete implementation plan.',
    },
    {
        heading: 'How is your programming delivered?',
        text: 'Virtual, Hybrid, Silicon Valley Residential Programming and we also establish'+
            ' satellite campuses/programs to work with you locally in your country.',
    },
];
export const sliderRightGlobal = [
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Maria_Sofia_Castillo/Maria_Sofia_Castillo.png ',
        person_name: 'Maria Sofia Castillo',
        date: 'January 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Maria_Sofia_Castillo/Core Code.png',
        width: '80%',
        company_name: 'Core Code',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Jennifer_Wong/Jennifer_Wong.png',
        person_name: 'Jannifer Wong',
        date: 'January 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Jennifer_Wong/Phyta Zenica.png',
        width: '75%',
        company_name: 'Phyta Zenica',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Murad_Nathani/Murad_Nathani.png',
        person_name: 'Murad Nathani',
        date: 'January 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Murad_Nathani/Sepio Solutions.png',
        width: '57%',
        company_name: 'Sepio',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_'+
        'Alumni/Alessandra_Menezes_Morelle/Alessandra_Menezes_Morelle.png',
        person_name: 'Menezes _Morelle',
        date: 'January 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Alessandra_Menezes_Morelle/thummi.svg',
        width: '100%',
        company_name: 'Thummi',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Jeff_Hu/Jeff_Hu.png',
        person_name: 'Jeff Hu',
        date: 'September 2021',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Jeff_Hu/turning curts.svg',
        width: '100%',
        company_name: 'Turing Certs',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Linjian_Xiang/Linjian_Xiang.png',
        person_name: 'Linjian Xiang',
        date: 'October 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Linjian_Xiang/Robolution.png',
        width: '50%',
        company_name: 'Robolution ',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Maria_Mateo_Iborra/Maria_Mateo_Iborra.png',
        person_name: 'Maria Meteo Iborra',
        date: 'June 2021',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Maria_Mateo_Iborra/Ibisa Network.png',
        width: '70%',
        company_name: 'Ibisa',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Amy_Chen/Amy_Chen.png',
        person_name: 'Amy Chen',
        date: 'June 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Amy_Chen/Vaultbase.png',
        width: '50%',
        company_name: 'Vaultbase ',
    },
];
export const socailLogoGlobal = [
    {
        img1: '/images/global_section/partner_logogs/UNDP_logo.svg',
        img1_width: '3vw',
        img1_height: '7vw',
        img2: '/images/global_section/partner_logogs/USAID.svg',
        img2_width: '8vw',
        img2_height: '4vw',
        img3: '/images/global_section/partner_logogs/Mitsubishi_Motors.png',
        img3_width: '5vw',
        img3_height: '7vw',
        img4: '/images/global_section/partner_logogs/monshaat.svg',
        img4_width: '5vw',
        img4_height: '5vw',
    },
    {
        img1: '/images/global_section/partner_logogs/ING.svg',
        img1_width: '10vw',
        img1_height: '3vw',
        img2: '/images/global_section/partner_logogs/Orange.svg',
        img2_width: '5vw',
        img2_height: '6vw',
        img3: '/images/global_section/partner_logogs/NIPA.svg',
        img3_width: '10vw',
        img3_height: '4vw',
        img4: '/images/global_section/partner_logogs/Turkish_Airlines.svg',
        img4_width: '7vw',
        img4_height: '2vw',
    },
    {
        img1: '/images/global_section/partner_logogs/SIDF.svg',
        img1_width: '7vw',
        img1_height: '5vw',
        img2: '/images/global_section/partner_logogs/KBW_Ventures.svg',
        img2_width: '10vw',
        img2_height: '5vw',
        img3: '/images/global_section/partner_logogs/MISK.svg',
        img3_width: '4vw',
        img3_height: '7vw',
        img4: '/images/global_section/partner_logogs/Sonatel.svg',
        img4_width: '7vw',
        img4_height: '4vw',
    },
    {
        img1: '/images/global_section/partner_logogs/KIC.svg',
        img1_width: '8vw',
        img1_height: '5vw',
        img2: '/images/global_section/partner_logogs/KISED.svg',
        img2_width: '8vw',
        img2_height: '7vw',
        img3: '/images/global_section/partner_logogs/dexis.svg',
        img3_width: '7vw',
        img3_height: '4vw',
        img4: '/images/global_section/partner_logogs/Growth_Circuit.svg',
        img4_width: '8vw',
        img4_height: '3vw',
    },
];
export const FaqHeroTraining = [
    {
        heading: 'How much does the program cost?',
        text: 'The cost is $12,000 for our 5 week Hero Training program including accommodation. ',
    },
    {
        heading: 'Can I apply if I already have an idea and a team?',
        text: 'Yes, we are looking for top talent and would love to have you at our accelerator. '+
        'You will gain access to our network and possibly raise money during Pitch Day. ',
    },
    {
        heading: `Can I apply if I don't have an idea yet?`,
        text: 'Yes you can! We are a human accelerator and looking for great future entrepreneurs whether '+
        'you have an early stage company, an idea or no idea yet.',
    },
    {
        heading: 'Can we choose our own roommates?',
        text: ' No, your roommates will be assigned by us. This is the perfect time for you to meet other '+
        'people! Each program has people from around over 30 different countries, which allows each person to '+
        'learn from people with different backgrounds and nationalities. This will help you see different '+
        'perspectives and grow your network.',
    },
    {
        heading: 'Are there any other accommodation options available?',
        text: 'Depending on the number of students participating the program, we might '+
        'offer different accommodation options. Don’t forget to talk to our extraordinary '+
        'admissions team if you have a special situation.',
    },
    {
        heading: 'Can we go out during the weekend to enjoy The Bay Area?',
        text: 'Of course! We encourage you to explore! ',
    },
    {
        heading: 'Are we expected to bring our laptops/computers?',
        text: 'Yes, you need to bring your own computer. ',
    },
    {
        heading: 'What is the SIM Card provider you recommended us?',
        text: ' It’s called Project Fi by Google, you can request one days '+
        'before arriving to DU and get it delivered to campus.',
    },
    {
        heading: 'Can I send any packages to Draper U before arriving?',
        text: 'Yes! Our address is 44 E 3rd Ave, San Mateo, CA 94401, USA.'+
        ' When you arrive, your packages will be waiting at the front desk.',
    },
    {
        heading: 'Will I get a certificate?',
        text: 'Yes!',
    },
    {
        heading: 'Are we going to learn coding?',
        text: `We do offer some coding workshops, but it's not a coding program. You will have a lot `+
        `of resources you can utilize if you want to learn more about it.`,
    },
    {
        heading: 'Can you explain Survival week in more detail?',
        text: ' It will be at the beginning of the program and leadership based.',
    },
    {
        heading: 'Is there free Wi-Fi?',
        text: 'Yes, of course!',
    },
    {
        heading: 'What will I take with me once I graduate from this program?',
        text: 'You will have the opportunity to grow your network in Silicon Valley, '+
        'grow your network of global innovators and light-minded individuals and you will get the '+
        'opportunity to be on the front line of emerging technologies and innovation. You will also '+
        'be a great leader after the program!',
    },
    {
        heading: 'Is there available parking?',
        text: 'Please do not bring cars to campus, we do not have any parking available for students. '+
        'There are several other options, including the train, as well as Uber and Lyft.',
    },
    {
        heading: 'Do you offer laundry services?',
        text: 'We have washers and dryers on campus, available for all of you! ',
    },
    {
        heading: 'Will we visit places outside of Draper University during the program?',
        text: 'Yes, we will be going to different conferences in the city, and networking events.',
    },
    {
        heading: 'Is the train station near Draper U?',
        text: 'Yes, it is two blocks away! You can find it on Google Maps',
    },
];
export const socailLogoInvest = [
    {
        img1: '/images/invest_logos/Helium_Health.svg',
        img1_width: '10vw',
        img1_height: '3vw',
        img2: '/images/invest_logos/Zahara.svg',
        img2_width: '6vw',
        img2_height: '6vw',
        img3: '/images/invest_logos/Leverage_Logo.svg',
        img3_width: '8vw',
        img3_height: '4vw',
        img4: '/images/invest_logos/Algorand.svg',
        img4_width: '6vw',
        img4_height: '6vw',
    },
    {
        img1: '/images/invest_logos/Yes_Theory.svg',
        img1_width: '6vw',
        img1_height: '6vw',
        img2: '/images/invest_logos/archform.svg',
        img2_width: '10vw',
        img2_height: '3vw',
        img3: '/images/invest_logos/Roby.svg',
        img3_width: '6vw',
        img3_height: '3vw',
        img4: '/images/invest_logos/Lepur.svg',
        img4_width: '6vw',
        img4_height: '6vw',
    },
    {
        img1: '/images/invest_logos/LumiereVR.svg',
        img1_width: '8vw',
        img1_height: '2vw',
        img2: '/images/invest_logos/Harmony_Protocol.svg',
        img2_width: '10vw',
        img2_height: '2vw',
        img3: '/images/invest_logos/neolight.svg',
        img3_width: '10vw',
        img3_height: '3vw',
        img4: '/images/invest_logos/Loopd_Inc.svg',
        img4_width: '6vw',
        img4_height: '6vw',
    },
    {
        img1: '/images/invest_logos/Exafinance.svg',
        img1_width: '6vw',
        img1_height: '6vw',
        img2: '/images/invest_logos/Juice.svg',
        img2_width: '6vw',
        img2_height: '4vw',
        img3: '/images/invest_logos/Group_15547.svg',
        img3_width: '6vw',
        img3_height: '6vw',
        img4: '/images/invest_logos/Registered_White.svg',
        img4_width: '8vw',
        img4_height: '3vw',
    },
    {
        img1: '/images/invest_logos/Newsy_Stock.svg',
        img1_width: '6vw',
        img1_height: '6vw',
        img2: '/images/invest_logos/Esports_One.png',
        img2_width: '6vw',
        img2_height: '5vw',
        img3: '/images/invest_logos/Basic_Block.svg',
        img3_width: '7vw',
        img3_height: '7vw',
        img4: '/images/invest_logos/GALY.svg',
        img4_width: '6vw',
        img4_height: '6vw',
    },
    {
        img1: '/images/invest_logos/Conquer.svg',
        img1_width: '10vw',
        img1_height: '3vw',
        img2: '/images/invest_logos/nVision.svg',
        img2_width: '10vw',
        img2_height: '3vw',
        img3: '/images/invest_logos/TakeBus.svg',
        img3_width: '10vw',
        img3_height: '7vw',
        img4: '/images/invest_logos/Bodega_Brands.svg',
        img4_width: '10vw',
        img4_height: '4.5vw',
    },
    {
        img1: '/images/invest_logos/Jointer_Smartswap.svg',
        img1_width: '6vw',
        img1_height: '6vw',
        img2: '/images/invest_logos/fxdx.svg',
        img2_width: '8vw',
        img2_height: '5vw',
        img3: '/images/invest_logos/drop.svg',
        img3_width: '10vw',
        img3_height: '2vw',
        img4: '/images/invest_logos/Digital_Zone.svg',
        img4_width: '8vw',
        img4_height: '3vw',
    },
];
export const blockchain = {
    backgroundImage: '/images/blockchain_page/blockchain.png',
    backgroundImageMobi: '/images/blockchain_page/blockchain_mbl.png',
    week: ' ',
    programName: 'BLOCKCHAIN  ACCELERATORS',
    programdescription: 'Partner with us to accelerate your blockchain ecosystem with superhero founders.',
    programdescription_mbl: 'Partner with us to accelerate your '+
    '<br> blockchain ecosystem with <br> superhero founders.',
    points: [{sesion: 'Spring, 2022'}, {sesion: ''}],
    points2: [{sesion: ''}, {sesion: ''}],
    img: '/images/3boxesProgrampagesSection2.svg',
    img_mbl: '/images/mobile.svg',
    success_description: 'Scaling Web3 Startups and Ecosystems Globally',
};
export const blockchainForSection = {
    number: ' 04',
    for: 'For...',
    points: [{
        title: 'Startup',
        description: `Scale with leaders in blockchain acceleration. From Draper's early '+
        'investments in Coinbase and Bitcoin to Boost VC backing Sci-Fi startups - We have'+
        ' believed in Web3 technology since day one. Let us help you build the right foundation or scale globally.`,
        action: 'APPLY NOW',
        goahead: '/images/corporative_section/Line 216.svg',
    },
    ],
    src1: '/images/corporative_section/83514589_2701812689937121_9056403443761020928_n.png',
    src2: '/images/corporative_section/Draper-startuphouse-startuptalky-1.png',
    src3: '/images/corporative_section/image-asset 2.png',
};
